import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage('hSkhCLMKA4nPzQUzC7FK7IVa0XcG8RhH957RUvdidDjgg1n71tByYtepKayimchZUNu6bzATuWyEejZxb8z1nO7sbeq39IZAAVvkJtc50kwAytbLdsFqzaEKJLTMdddY', {
    encAlgorithm: 'Rabbit',
    doNotEncryptValues: false,
})